import { createSelector } from 'reselect';
import includes from 'lodash/includes';
import filter from 'lodash/filter';
import { isMinor as isMinorHelper } from 'helpers/datetime';
import * as actionTypes from './actionTypes';
import * as constants from './constants';
/**
 * Input selectors
 */ const mainSelector = (state)=>state[constants.MODULE_ID];
const sendingSelector = (state)=>state[constants.MODULE_ID].sending;
const fetchingSelector = (state)=>state[constants.MODULE_ID].fetching;
const errorsSelector = (state)=>state[constants.MODULE_ID].errors;
export const information = createSelector(mainSelector, (state)=>state.information);
export const informationTemplate = createSelector(mainSelector, (state)=>state.informationTemplate);
export const consentsTemplate = createSelector(mainSelector, (state)=>state.consentsTemplate);
export const isFetchConsentsTemplateInProgress = createSelector(fetchingSelector, (state)=>includes(state, actionTypes.FETCH_CONSENTS_TEMPLATE));
export const hasFetchConsentsTemplateErrors = createSelector(errorsSelector, (state)=>includes(state, actionTypes.FETCH_CONSENTS_TEMPLATE));
export const mandatoryConsentTemplate = createSelector([
    consentsTemplate
], (consentsTemplateState)=>filter(consentsTemplateState, {
        isMandatory: true
    }));
export const isNoMandatoryConsent = createSelector(mainSelector, (state)=>state.isNoMandatoryConsent);
export const isNoMandatoryInformation = createSelector(mainSelector, (state)=>state.isNoMandatoryInformation);
export const isNotMinor = createSelector([
    information
], (informationState)=>!informationState.dateOfBirth || !isMinorHelper(informationState.dateOfBirth));
//----------------------------------------------------------------------------------------------------------------------
export const isSendInformationInProgress = createSelector(sendingSelector, (state)=>includes(state, actionTypes.SEND_INFORMATION));
export const hasSendInformationErrors = createSelector(errorsSelector, (state)=>includes(state, actionTypes.SEND_INFORMATION));
